export default __webpack_public_path__ + "static/media/gallery-wip-pommel_03.96debbb5.jpg";